import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useUIControlsStore } from '../../../redux/features/ui-controls';
import { usePostPanStore, usePrePanStore } from '../../../redux';

import GrayCrossIcon from '../../../assets/apply-refer-code/gray-cross-icon.svg';
import SettingsIcon from '../../../assets/auto-debit/settings-icon-nach-cancel.png';

const HorizontalProgressBar = () => {
  const navigate = useNavigate();
  const {
    horizontalProgressBarProgress,
    showHorizontalProgressBar,
    updateInJourneyQuitFlag,
    isSideDrawerOpen,
    onlyCrossIcon,
  } = useUIControlsStore();

  const { prepanDetailsType, softRejectionFlag, onScreenComp } =
    usePrePanStore();

  const {
    detailsType,
    softRejectionFlag: postpanSoftRejctionFlag,
    onScreenComp: postpanOnScreenComp,
  } = usePostPanStore();

  const location = useLocation();
  const { pathname } = location;

  const [showNachCancellationOption, setShowNachCancellationOption] =
    useState(true);
  const [showNachCancellationDropdown, setShowNachCancellationDropdown] =
    useState(false);

  // const NO_CROSS_ICON = ['/pre-pan'];

  const openConfirmExitWindow = () => {
    // DOCS: Open the Confirm quit modal and redirect to dashboard if user clicks yes
    updateInJourneyQuitFlag(true);
  };

  const nachCancellationSettingsIconClicked = () => {
    setShowNachCancellationDropdown(!showNachCancellationDropdown);
  };

  const closeHandler = () => {
    if (pathname === '/upload-bs') {
      navigate('/edit-profile');
    } else {
      openConfirmExitWindow();
    }
  };

  const renderCrossIcon = () => {
    if (pathname === '/pre-pan') {
      if (softRejectionFlag) {
        return false;
      } else {
        return (
          prepanDetailsType === 'CONVERSATIONAL' &&
          !onScreenComp.includes('WELCOME_SCR') &&
          !onScreenComp.includes('SUCCESS_SCREEN')
        );
      }
    } else if (pathname === '/post-pan') {
      if (postpanSoftRejctionFlag) {
        return false;
      } else {
        return (
          detailsType === 'CONVERSATIONAL' &&
          !postpanOnScreenComp.includes('WELCOME_SCR') &&
          !postpanOnScreenComp.includes('SUCCESS_SCREEN')
        );
      }
    }
    return false;
  };

  const redirectToNachCancellation = () => {
    setShowNachCancellationDropdown(false);
    navigate('/nach-cancellation/start');
  };

  // DOCS: Desktop case (Auto debit page only) and eligible for cancellation
  if (
    pathname === '/auto-debit' &&
    showNachCancellationOption &&
    window.innerWidth > 1024
  ) {
    return (
      <div className="w-full relative flex justify-end z-[100] bg-red-800">
        {' '}
        {/* {showNachCancellationOption ? (
          <>
            <div
              className={`absolute cursor-pointer right-4 top-4 w-8 h-8 ml-auto  max-w-[25%] bg-transparent ${
                isSideDrawerOpen ? 'z-0' : 'z-10'
              } ${'flex '}`}
              onClick={nachCancellationSettingsIconClicked}
            >
              <img
                src={SettingsIcon}
                alt="Settings Icon"
                className="relative bg-[#F6F5F1] p-[7px] rounded-full"
              />
              {showNachCancellationDropdown ? (
                <div className="absolute top-8 right-0 z-10 mt-1 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1" role="none">
                    <span
                      className="text-gray-700 block px-2 py-2 text-sm"
                      onClick={redirectToNachCancellation}
                    >
                      Cancel mandate
                    </span>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </>
        ) : (
          ''
        )} */}
      </div>
    );
  }

  return (
    <>
      {showHorizontalProgressBar ? (
        <>
          <div className="w-full relative">
            <div
              className={`w-full ${
                horizontalProgressBarProgress ? ' bg-gray-200 ' : ''
              } h-2 bg-gray-200 ${onlyCrossIcon ? 'hidden' : 'block'}`}
            >
              <div
                className={`bg-[#079F9F] h-2 absolute ${
                  isSideDrawerOpen ? 'z-0' : 'z-[1]'
                }`}
                style={{
                  width: `${horizontalProgressBarProgress}%`,
                  transition: 'width 0.5s ease-in-out',
                }}
              ></div>
            </div>
            {/* {showNachCancellationOption ? (
              <>
                <div
                  className={`fixed cursor-pointer right-14 top-4 w-8 h-8 ml-auto  max-w-[25%] bg-transparent ${
                    isSideDrawerOpen ? 'z-0' : 'z-10'
                  } ${'flex lg:hidden'}`}
                  onClick={nachCancellationSettingsIconClicked}
                >
                  <img
                    src={SettingsIcon}
                    alt="Settings Icon"
                    className="relative bg-[#F6F5F1] p-[7px] rounded-full"
                  />
                  {showNachCancellationDropdown ? (
                    <div className="absolute top-8 right-0 z-10 mt-1 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div className="py-1" role="none">
                        <span
                          className="text-gray-700 block px-2 py-2 text-sm"
                          onClick={redirectToNachCancellation}
                        >
                          Cancel mandate
                        </span>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </>
            ) : (
              ''
            )} */}
            <div
              className={`fixed cursor-pointer right-12 top-4 w-8 h-8 ml-auto  max-w-[25%] bg-transparent ${
                isSideDrawerOpen ? 'z-0' : 'z-10'
              } ${renderCrossIcon() ? 'hidden' : 'flex lg:hidden'}`}
              onClick={closeHandler}
            >
              <img
                src={GrayCrossIcon}
                alt="Cross Icon"
                className="bg-[#F6F5F1] p-[7px] rounded-full hidden"
              />
              <p className="m-auto">Close</p>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default HorizontalProgressBar;
